import { useMyHubsList } from "hooks/user-profile/useUserProfile";
import { useMemo } from "react";
import { mapMyHubsToSelectOptions } from "./hubMultiSelectUtils";

export function useHubMultiSelectOptions({
  queryKey = "hub-multi-select",
  enabled = true,
  params = {},
} = {}) {
  const { data: myHubsData, isLoading, isFetching, refetch } = useMyHubsList({
    enabled,
    queryKey,
    params,
  });

  const hubSelectOptions = useMemo(
    () => mapMyHubsToSelectOptions(myHubsData),
    [myHubsData]
  );

  return {
    myHubsData,
    hubSelectOptions,
    isLoading,
    isFetching,
    refetch,
  };
}
